import RepresenterEntity from "../RepresenterEntity";

export default class AgentEntity extends RepresenterEntity {
    constructor() {
        super();
    }
}
